var React = require('react');
var PropTypes = React.PropTypes;
import ReactDOM from 'react-dom';

var PartResult = React.createClass({
  getInitialState: function() {
    return {
      answer: this.props.answer,
      content: this.props.content,
      info: this.props.info
    };
  },

  componentWillReceiveProps: function(nextProps) {
    this.setState({
      answer: nextProps.answer || this.state.answer,
      info: nextProps.info || this.state.info
    })
  },

  replaceAll:function(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
},

  render: function() {
    var answer = this.state.answer;
    var info = this.state.info;
    var contentFinalAnswer = answer.result;
    var finalAns = "";
    
    if (contentFinalAnswer!=null) { 
      var splitAnswer = contentFinalAnswer.split('<math xmlns="http://www.w3.org/1998/Math/MathML">'); //get rid of this
      finalAns = splitAnswer[1];
      finalAns = this.replaceAll(finalAns,"<mi>","");
      finalAns = this.replaceAll(finalAns,"</mi>","");
      finalAns = this.replaceAll(finalAns,"<mn>","");
      finalAns = this.replaceAll(finalAns,"</mn>","");
      finalAns = this.replaceAll(finalAns,"</math>","");
    }

    console.log(info)
    console.log("FINAL ANSWER IS " + finalAns);
    return (
      <div className="padding-15" style={{borderBottom: "1px solid #ccc"}}>
        <h3 style={{fontSize: "20px", margin: "0 0 15px 0"}}>Final Answer</h3>
        <div dangerouslySetInnerHTML={{__html: finalAns}}></div>
        {
          !answer.isRight && info.text && info.type === "AUTO_MARKING" &&
          <div>
            <div dangerouslySetInnerHTML={{__html: answer.result}} style={{color: "red"}}></div>
            <div>  Correct Answer: <span dangerouslySetInnerHTML={{__html: info.text}} style={{color: "red"}}></span></div>
          </div>
        }
        {
          !answer.isRight && !info.text && 
          <div>
            <div dangerouslySetInnerHTML={{__html: answer.result}}></div>
          </div>
        }
        {
          answer.isRight && info.type === "AUTO_MARKING" &&
          <div>
            <div dangerouslySetInnerHTML={{__html: answer.result}} style={{color: "green"}}></div>
            <div>  Correct Answer: <span dangerouslySetInnerHTML={{__html: info.text}} style={{color: "green"}}></span></div>
          </div>
        }
      </div>
    );
  },
  componentDidUpdate: function(prevProps) {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },

});

module.exports = PartResult;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/LongQuestionFraction/PartResult.js
 **/